import React from 'react'
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
import { Tracker } from "../../../../../../util/analytics";
import { getUser } from "../../../../../../util/helpers";
import * as configuration from "../../../../_redux/state/configurationRedux";
export default function ConfigurationSideBar() {
  const dispatch = useDispatch();
  const categories = useSelector((state) => {
    return state.configuration.callCategories;
  });

  useEffect(() => {
    if (categories && categories.results.length > 0) {
      dispatch(
        configuration.actions.callSelectedGenericCategory(categories.results[0])
      );
    }
  }, [categories]);

  const handleClick = (category) => {
    Tracker.event(
      "Reports",
      "Click",
      "Select Reports Click",
      `${category.name}`,
      getUser()
    );
    dispatch(configuration.actions.callSelectedGenericCategory(category));
  };

  const selectedCategory = useSelector((state) => {
    return state.configuration.callSelectedGenericCategory;
  });

  return (
    <div
      className="card w-100"
      style={{
        backgroundColor: "#fff",
        height: "calc(100vh)",
        position: "sticky",
        top: "0px",
      }}
    >
      <div
        style={{ fontSize: "16px", fontWeight: 500, margin: "32px 0 0 20px" }}
      >
        Select Reports
      </div>
      <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
        <div style={{ marginLeft: "20px" }}>
          <div
            className={`configuration-sidebar-item active`}
            style={{ cursor: "pointer", marginBottom: "10px" }}
          >
            <div className="d-flex">
              <img
                src={toAbsoluteUrl("/media/sr/icons/report-4.png")}
                alt=""
                style={{ height: "19px", marginRight: "10px" }}
              />
              Standard Reports
            </div>
            <div>{">"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
